<template>
  <v-dialog v-model="dialog" width="550">
    <template v-slot:activator="{}">
      <BaseButton
        v-if="create"
        @click="openModal"
        :text="
          localStorage.translations.pages.personnel_department[
            'employees-group_dialog_create-edit_buttons'
          ]['sozdat-podrazdelenie']
        "
        default_icon="button-add"
      />

      <EditBtn v-else :bigClick="openModal" :big="true" />
    </template>
    <transition :duration="150">
      <EmployeesGroupCreateAndEditModalForm
        v-if="dialog"
        @input="dialog = false"
        :id="id"
        :dialog="dialog"
        :closeModal="closeModal"
        :create="create"
      />
    </transition>
  </v-dialog>
</template>

<script>
import EditBtn from 'components/EditBtn'
import EmployeesGroupCreateAndEditModalForm from 'components/employees/group/EmployeesGroupCreateAndEditModalForm'

export default {
  name: 'EmployeesGroupCreateAndEditModal',
  components: { EmployeesGroupCreateAndEditModalForm, EditBtn },
  props: ['id', 'create', 'minimalize'],
  data() {
    return {
      dialog: false,
    }
  },
  methods: {
    openModal() {
      this.dialog = true
    },
    closeModal() {
      this.dialog = false
    },
  },
}
</script>

<style lang="scss" scoped></style>
